// src/services/vibeSocial.js — the browser's calls to the social routes:
// tags, reactions, edits, translation, stories — and my own date of birth.
// The phone's twin is services/vibeCommentApi.ts (postJson and the calls after it)
// and services/myDob.ts.
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import { BACKEND_URL } from './socket';

/** { ok:false } with no status when the server was not reached; its own answer when it was. */
export async function postJson(path, body) {
  let token = null;
  try { token = await auth.currentUser?.getIdToken(); } catch { token = null; }
  if (!token) return { ok: false };
  try {
    const res = await fetch(`${BACKEND_URL}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify(body || {}),
    });
    let j = null;
    try { j = await res.json(); } catch { j = null; }
    if (!res.ok || !j) return { ok: false, status: res.status, ...(j || {}) };
    return j;
  } catch { return { ok: false }; }
}

/* 🏷 tags — server/functions/tagRoutes.js */
export const announceTags = (postId) => postJson('/api/vibes/tags/announce', { postId });
export const respondTag = (postId, accept) => postJson('/api/vibes/tags/respond', { postId, accept: !!accept });
export const removeTag = (postId, uid) => postJson('/api/vibes/tags/remove', uid ? { postId, uid } : { postId });

/* 🎂 MY DATE OF BIRTH, OWNER-ONLY. It lived on the public user document, where
   every signed-in account (and on the web that includes anonymous visitors)
   could read it. users/{uid}/private/dob now; the public document says only
   `hasDob: true`. Readers prefer the private copy and fall back to the public
   field, so an account the migration has not reached behaves as before. */
const _dob = new Map();   // uid → Date | null
export async function readMyDob(uid) {
  if (!uid) return null;
  if (_dob.has(uid)) return _dob.get(uid);
  let d = null;
  try {
    const s = await getDoc(doc(db, 'users', uid, 'private', 'dob'));
    const v = s.exists() ? (s.data() || {}).dateOfBirth : null;
    if (v) { d = typeof v.toDate === 'function' ? v.toDate() : new Date(v); if (Number.isNaN(d.getTime())) d = null; }
  } catch { d = null; }
  _dob.set(uid, d);
  return d;
}
export function knownDob(uid) { return _dob.has(uid) ? _dob.get(uid) : undefined; }

export function browserTimeZone() {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || null; } catch { return null; }
}

/* ⚖️ the date of birth is written by the SERVER now (services/legal sendDob → server/functions/legal.js);
   this tab only remembers what it was told, so the gate does not read it again */
export function rememberDob(uid, dob) { if (uid && dob) _dob.set(uid, dob); }
